import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";

// Agreeing to Eldan's terms of use and privacy policy - required before sending
const TermsAcceptance = ({ formData, handleCheckboxChange }) => (
  <Grid item xs={12}>
    <FormControlLabel
      control={
        <Checkbox
          required
          checked={formData.termsAccepted}
          onChange={handleCheckboxChange("termsAccepted")}
        />
      }
      label={
        <Typography variant="body2">
          אני מאשר/ת כי פרטיי יישמרו במאגר מידע של אלדן מקבוצת ניאופרם
          בכפוף{" "}
          <a
            href="https://www.eldan.biz/website-terms-of-use-page/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#006699" }}
          >
            לתקנון
          </a>{" "}
          ו
          <a
            href="https://www.eldan.biz/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#006699" }}
          >
            מדיניות הפרטיות
          </a>{" "}
          כמפורט{" "}
          <a
            href="https://www.eldan.biz/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#006699" }}
          >
            באתר החברה
          </a>
        </Typography>
      }
    />
  </Grid>
);

export default TermsAcceptance;
